module.exports = __webpack_public_path__ + "img/sld_mfm_ic_1_t1_b1_dark.305e265e.svg";